import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get';
import ElementInteraction from './element-interaction';

var CCElementInteraction = function CCElementInteraction(props) {
  var elementInteractionProps = _objectSpread(_objectSpread({}, props), {}, {
    eventName: 'CC_ELEMENT_INTERACTION_EVENT',
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    impressionId: props.impressionId
  });

  var ccData = {
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    productId: props.productId,
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    productImpressionId: props.productImpressionId
  };
  return /*#__PURE__*/React.createElement(ElementInteraction, _extends({
    verticalInteractionData: ccData
  }, elementInteractionProps));
};

CCElementInteraction.propTypes = {
  productId: PropTypes.number.isRequired,
  impressionId: PropTypes.string,
  productImpressionId: PropTypes.string,
  productImpressionKey: PropTypes.string
};
export default CCElementInteraction;
var CCElementInteractionConnect = connect(function (state, ownProps) {
  return {
    impressionId: get(state, "impressions[".concat(ownProps.id, "].elementImpressionHeader.impressionId")),
    productImpressionId: get(state, "impressions[".concat(ownProps.productImpressionKey, "].impressionHeader.impressionId"))
  };
})(CCElementInteraction);
export { CCElementInteractionConnect };